import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {IntlProvider, addLocaleData} from 'react-intl';
import serverVars from 'server-vars';
import { addLoginHandlers } from '../utils/loginHandlers';

import { actionCreators } from '../actions';
import {
    headerRootQuery,
    headerInitialVariables,
    HeaderRenderer,
    mobileNavWrapperRootQuery,
    mobileNavWrapperInitialVariables,
    MobileNavWrapperRenderer
} from '../components';

const getBuyerHeaderClient = ({ node, store, relayEnv }) => {

    const isMobile = serverVars.get('settings.isMobile');

    const initialVariables = isMobile ? mobileNavWrapperInitialVariables : headerInitialVariables;
    const query = isMobile ? mobileNavWrapperRootQuery : headerRootQuery;

    const localeDataKey = serverVars.get('localeDataKey');
    const messages = serverVars.get('dblMessages');

    if (window.ReactIntlLocaleData) {
        addLocaleData(window.ReactIntlLocaleData[localeDataKey]);
    }

    const props = {
        initialVariables,
        environment: relayEnv,
        query
    };

    addLoginHandlers(() => {
        store.dispatch(actionCreators.setUpdateUserState(true));
    });

    ReactDOM.render(
        <IntlProvider locale={localeDataKey} messages={messages}>
            <Provider store={store}>
                {
                    isMobile ?
                        <MobileNavWrapperRenderer {...props }/> :
                        <HeaderRenderer {...props} />
                }
            </Provider>
        </IntlProvider>,
        node
    );

    return {
        store,
        getBuyerHeaderUiState: store.getState
    };
};


export {
    getBuyerHeaderClient
};



// WEBPACK FOOTER //
// ./src/entries/header.js